import classes from './RealPlayView.module.scss';
import { Skeleton } from '@material-ui/lab';
import RealPlayViewLogic from './RealPlayView.logic';
import RealPlayInfo from './RealPlayInfo/RealPlayInfo';
import RealPlayClientInfo from './RealPlayClientInfo/RealPlayClientInfo';
import RealPlaySubmit from './RealPlaySubmit/RealPlaySubmit';
import RealPlayHeader from './RealPlayHeader/RealPlayHeader';
import RealPlayRecorder from './RealPlayRecorder/RealPlayRecorder';
const RealPlayView = () => {
  const { isLoading, aiProspectOption } = RealPlayViewLogic();
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        {isLoading ? (
          <>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="rect" width="100%" height="85vh" />
          </>
        ) : (
          <>
            <RealPlayHeader />
            <RealPlayRecorder aiProspectOption={aiProspectOption} />
          </>
        )}
      </div>
      <div className={classes.right}>
        {isLoading ? (
          <Skeleton variant="rect" width="100%" height="85vh" />
        ) : (
          <>
            <RealPlayInfo />
            <RealPlayClientInfo />
            <RealPlaySubmit />{' '}
          </>
        )}
      </div>
    </div>
  );
};

export default RealPlayView;
